export default {"src":"/_next/static/media/Master-badge.8c4ed014.svg","height":68,"width":69};